// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   MedGen Layout & Navigation — Responsive Stylesheet (AppLayout.responsive.css)
   Targets: Mobile screens (<=768px, <=480px) and Tablets / iPad (<=1024px, <=1180px)
   DESKTOP (>=1025px / >1180px) REMAINS 100% UNTOUCHED
   ========================================================================== */

/* ==========================================================================
   TABLET / IPAD (max-width: 1180px)
   ========================================================================== */
@media (max-width: 1180px) {
  /* Prevent any horizontal body overflow */
  html, body, #root, .app-shell {
    max-width: 100vw;
    overflow-x: hidden;
  }

  .app-layout-shell {
    width: 100%;
    max-width: 100vw;
    margin-left: 0 !important;
    padding: 0 !important;
    overflow-x: hidden;
  }

  .app-layout-main {
    width: 100%;
    max-width: 100vw;
    box-sizing: border-box;
  }

  /* Topbar container */
  .topbar,
  .medgen-topbar {
    min-height: 64px !important;
    padding: 10px 16px !important;
    gap: 12px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    flex-wrap: nowrap !important;
    position: sticky !important;
    top: 0 !important;
    z-index: 900 !important;
    backdrop-filter: blur(14px) !important;
    -webkit-backdrop-filter: blur(14px) !important;
  }

  .topbar-left,
  .medgen-topbar .topbar-left {
    display: flex !important;
    align-items: center !important;
    gap: 10px !important;
    flex: 1 1 auto !important;
    min-width: 0 !important;
  }

  .topbar-right,
  .medgen-topbar .topbar-right {
    display: flex !important;
    align-items: center !important;
    gap: 8px !important;
    flex: 0 0 auto !important;
  }

  .topbar-title,
  .medgen-topbar .topbar-title {
    font-size: 16px !important;
    font-weight: 800 !important;
    line-height: 1.2 !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }

  .topbar-subtitle,
  .medgen-topbar .topbar-subtitle {
    font-size: 11px !important;
    opacity: 0.8 !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }

  /* Hamburger touch target */
  .hamburger-btn,
  .medgen-topbar .hamburger-btn {
    width: 40px !important;
    height: 40px !important;
    border-radius: 10px !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
    align-items: center !important;
    gap: 4px !important;
    padding: 0 !important;
    cursor: pointer !important;
    flex-shrink: 0 !important;
  }

  .hamburger-btn span {
    width: 18px !important;
    height: 2px !important;
    border-radius: 2px !important;
  }

  /* Mobile Drawer */
  .mobile-drawer-backdrop {
    position: fixed !important;
    inset: 0 !important;
    background: rgba(3, 6, 12, 0.72) !important;
    backdrop-filter: blur(8px) !important;
    -webkit-backdrop-filter: blur(8px) !important;
    z-index: 1050 !important;
  }

  .mobile-drawer {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: min(320px, 86vw) !important;
    height: 100dvh !important;
    padding: 20px 16px !important;
    background: linear-gradient(180deg, #06101f 0%, #0a182a 100%) !important;
    border-right: 1px solid rgba(24, 183, 255, 0.18) !important;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5) !important;
    z-index: 1100 !important;
    display: flex !important;
    flex-direction: column !important;
    overflow-y: auto !important;
    -webkit-overflow-scrolling: touch !important;
  }

  .mobile-drawer-header {
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    padding-bottom: 16px !important;
    margin-bottom: 16px !important;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
  }

  .mobile-drawer-header h3 {
    margin: 0 !important;
    color: #ffffff !important;
    font-size: 16px !important;
    font-weight: 800 !important;
    letter-spacing: -0.01em !important;
  }

  .mobile-drawer-header .btn {
    padding: 6px 12px !important;
    font-size: 12px !important;
    border-radius: 8px !important;
    background: rgba(255, 255, 255, 0.08) !important;
    color: #d2e6f8 !important;
    border: 1px solid rgba(255, 255, 255, 0.12) !important;
  }

  .mobile-drawer .app-sidebar-inner {
    padding: 0 !important;
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
  }

  .mobile-drawer .app-sidebar-title {
    color: #89bfe8 !important;
    font-size: 10px !important;
    font-weight: 900 !important;
    letter-spacing: 0.18em !important;
    text-transform: uppercase !important;
    margin-bottom: 10px !important;
  }

  .mobile-drawer .app-nav-link {
    display: flex !important;
    align-items: center !important;
    min-height: 44px !important;
    padding: 10px 14px !important;
    border-radius: 10px !important;
    font-size: 14px !important;
    font-weight: 650 !important;
    color: rgba(220, 235, 250, 0.85) !important;
    background: transparent !important;
    margin-bottom: 4px !important;
    transition: all 0.16s ease !important;
    text-decoration: none !important;
  }

  .mobile-drawer .app-nav-link:hover,
  .mobile-drawer .app-nav-link.active {
    background: rgba(31, 123, 193, 0.22) !important;
    color: #ffffff !important;
    border: 1px solid rgba(24, 183, 255, 0.3) !important;
  }

  .mobile-drawer .app-nav-link.active {
    box-shadow: 0 4px 16px rgba(24, 183, 255, 0.16) !important;
  }

  /* Modals on iPad */
  .modal-backdrop,
  .admin-modal-backdrop {
    padding: 16px !important;
    overflow-y: auto !important;
    -webkit-overflow-scrolling: touch !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }

  .wizard-modal,
  .admin-modal {
    width: min(92vw, 640px) !important;
    max-height: 90vh !important;
    overflow-y: auto !important;
    border-radius: 18px !important;
    padding: 22px !important;
  }
}

/* ==========================================================================
   MOBILE PHONES (max-width: 768px)
   ========================================================================== */
@media (max-width: 768px) {
  .topbar,
  .medgen-topbar {
    min-height: 58px !important;
    padding: 8px 10px !important;
    gap: 8px !important;
  }

  .medgen-topbar .topbar-subtitle {
    display: none !important;
  }

  .topbar-title,
  .medgen-topbar .topbar-title {
    font-size: 15px !important;
  }

  .brand-mark,
  .brand-mark-logo {
    width: 32px !important;
    height: 32px !important;
    flex: 0 0 32px !important;
  }

  /* Right side compacting */
  .medgen-topbar .theme-toggle {
    min-width: 0 !important;
    padding: 6px 9px !important;
    font-size: 11px !important;
    white-space: nowrap !important;
  }

  .medgen-topbar .btn-secondary {
    padding: 6px 10px !important;
    font-size: 11px !important;
  }

  .medgen-topbar .user-chip {
    padding: 4px 8px 4px 4px !important;
    gap: 6px !important;
  }

  .medgen-topbar .user-name {
    font-size: 11px !important;
    max-width: 60px !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }

  .medgen-topbar .user-role {
    display: none !important;
  }

  .medgen-topbar .user-avatar {
    width: 26px !important;
    height: 26px !important;
    font-size: 10px !important;
  }

  /* Modals on mobile */
  .wizard-modal,
  .admin-modal {
    width: 95vw !important;
    max-height: 94vh !important;
    padding: 16px 14px !important;
    border-radius: 14px !important;
  }

  .wizard-header h2,
  .admin-modal-header h2 {
    font-size: 18px !important;
  }
}

/* ==========================================================================
   TINY MOBILE (max-width: 480px)
   ========================================================================== */
@media (max-width: 480px) {
  .topbar,
  .medgen-topbar {
    padding: 6px 8px !important;
  }

  .topbar-title,
  .medgen-topbar .topbar-title {
    font-size: 14px !important;
  }

  .medgen-topbar .theme-toggle {
    padding: 5px 8px !important;
    font-size: 10px !important;
  }

  .medgen-topbar .user-name {
    display: none !important;
  }

  .medgen-topbar .user-chip {
    padding: 3px !important;
    border-radius: 50% !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AppLayout.responsive.css"],"names":[],"mappings":"AAAA;;;;+EAI+E;;AAE/E;;+EAE+E;AAC/E;EACE,yCAAyC;EACzC;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA,qBAAqB;EACrB;;IAEE,2BAA2B;IAC3B,6BAA6B;IAC7B,oBAAoB;IACpB,wBAAwB;IACxB,8BAA8B;IAC9B,yCAAyC;IACzC,4BAA4B;IAC5B,2BAA2B;IAC3B,iBAAiB;IACjB,uBAAuB;IACvB,sCAAsC;IACtC,8CAA8C;EAChD;;EAEA;;IAEE,wBAAwB;IACxB,8BAA8B;IAC9B,oBAAoB;IACpB,yBAAyB;IACzB,uBAAuB;EACzB;;EAEA;;IAEE,wBAAwB;IACxB,8BAA8B;IAC9B,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;;IAEE,0BAA0B;IAC1B,2BAA2B;IAC3B,2BAA2B;IAC3B,8BAA8B;IAC9B,2BAA2B;IAC3B,kCAAkC;EACpC;;EAEA;;IAEE,0BAA0B;IAC1B,uBAAuB;IACvB,8BAA8B;IAC9B,2BAA2B;IAC3B,kCAAkC;EACpC;;EAEA,2BAA2B;EAC3B;;IAEE,sBAAsB;IACtB,uBAAuB;IACvB,8BAA8B;IAC9B,wBAAwB;IACxB,iCAAiC;IACjC,kCAAkC;IAClC,8BAA8B;IAC9B,mBAAmB;IACnB,qBAAqB;IACrB,0BAA0B;IAC1B,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,6BAA6B;EAC/B;;EAEA,kBAAkB;EAClB;IACE,0BAA0B;IAC1B,mBAAmB;IACnB,2CAA2C;IAC3C,qCAAqC;IACrC,6CAA6C;IAC7C,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;IAC1B,iBAAiB;IACjB,kBAAkB;IAClB,kCAAkC;IAClC,yBAAyB;IACzB,6BAA6B;IAC7B,wEAAwE;IACxE,2DAA2D;IAC3D,qDAAqD;IACrD,wBAAwB;IACxB,wBAAwB;IACxB,iCAAiC;IACjC,2BAA2B;IAC3B,4CAA4C;EAC9C;;EAEA;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,yCAAyC;IACzC,+BAA+B;IAC/B,8BAA8B;IAC9B,4DAA4D;EAC9D;;EAEA;IACE,oBAAoB;IACpB,yBAAyB;IACzB,0BAA0B;IAC1B,2BAA2B;IAC3B,kCAAkC;EACpC;;EAEA;IACE,4BAA4B;IAC5B,0BAA0B;IAC1B,6BAA6B;IAC7B,gDAAgD;IAChD,yBAAyB;IACzB,sDAAsD;EACxD;;EAEA;IACE,qBAAqB;IACrB,kCAAkC;IAClC,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;IACzB,0BAA0B;IAC1B,2BAA2B;IAC3B,iCAAiC;IACjC,oCAAoC;IACpC,8BAA8B;EAChC;;EAEA;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,2BAA2B;IAC3B,6BAA6B;IAC7B,8BAA8B;IAC9B,0BAA0B;IAC1B,2BAA2B;IAC3B,2CAA2C;IAC3C,kCAAkC;IAClC,6BAA6B;IAC7B,qCAAqC;IACrC,gCAAgC;EAClC;;EAEA;;IAEE,+CAA+C;IAC/C,yBAAyB;IACzB,oDAAoD;EACtD;;EAEA;IACE,0DAA0D;EAC5D;;EAEA,mBAAmB;EACnB;;IAEE,wBAAwB;IACxB,2BAA2B;IAC3B,4CAA4C;IAC5C,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;EACpC;;EAEA;;IAEE,kCAAkC;IAClC,2BAA2B;IAC3B,2BAA2B;IAC3B,8BAA8B;IAC9B,wBAAwB;EAC1B;AACF;;AAEA;;+EAE+E;AAC/E;EACE;;IAEE,2BAA2B;IAC3B,4BAA4B;IAC5B,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,sBAAsB;IACtB,uBAAuB;IACvB,yBAAyB;EAC3B;;EAEA,0BAA0B;EAC1B;IACE,uBAAuB;IACvB,2BAA2B;IAC3B,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;IACE,4BAA4B;IAC5B,0BAA0B;EAC5B;;EAEA;IACE,mCAAmC;IACnC,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,0BAA0B;IAC1B,8BAA8B;IAC9B,2BAA2B;IAC3B,kCAAkC;EACpC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;EAC5B;;EAEA,qBAAqB;EACrB;;IAEE,sBAAsB;IACtB,2BAA2B;IAC3B,6BAA6B;IAC7B,8BAA8B;EAChC;;EAEA;;IAEE,0BAA0B;EAC5B;AACF;;AAEA;;+EAE+E;AAC/E;EACE;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;IAC3B,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,uBAAuB;IACvB,6BAA6B;EAC/B;AACF","sourcesContent":["/* ==========================================================================\n   MedGen Layout & Navigation — Responsive Stylesheet (AppLayout.responsive.css)\n   Targets: Mobile screens (<=768px, <=480px) and Tablets / iPad (<=1024px, <=1180px)\n   DESKTOP (>=1025px / >1180px) REMAINS 100% UNTOUCHED\n   ========================================================================== */\n\n/* ==========================================================================\n   TABLET / IPAD (max-width: 1180px)\n   ========================================================================== */\n@media (max-width: 1180px) {\n  /* Prevent any horizontal body overflow */\n  html, body, #root, .app-shell {\n    max-width: 100vw;\n    overflow-x: hidden;\n  }\n\n  .app-layout-shell {\n    width: 100%;\n    max-width: 100vw;\n    margin-left: 0 !important;\n    padding: 0 !important;\n    overflow-x: hidden;\n  }\n\n  .app-layout-main {\n    width: 100%;\n    max-width: 100vw;\n    box-sizing: border-box;\n  }\n\n  /* Topbar container */\n  .topbar,\n  .medgen-topbar {\n    min-height: 64px !important;\n    padding: 10px 16px !important;\n    gap: 12px !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: space-between !important;\n    flex-wrap: nowrap !important;\n    position: sticky !important;\n    top: 0 !important;\n    z-index: 900 !important;\n    backdrop-filter: blur(14px) !important;\n    -webkit-backdrop-filter: blur(14px) !important;\n  }\n\n  .topbar-left,\n  .medgen-topbar .topbar-left {\n    display: flex !important;\n    align-items: center !important;\n    gap: 10px !important;\n    flex: 1 1 auto !important;\n    min-width: 0 !important;\n  }\n\n  .topbar-right,\n  .medgen-topbar .topbar-right {\n    display: flex !important;\n    align-items: center !important;\n    gap: 8px !important;\n    flex: 0 0 auto !important;\n  }\n\n  .topbar-title,\n  .medgen-topbar .topbar-title {\n    font-size: 16px !important;\n    font-weight: 800 !important;\n    line-height: 1.2 !important;\n    white-space: nowrap !important;\n    overflow: hidden !important;\n    text-overflow: ellipsis !important;\n  }\n\n  .topbar-subtitle,\n  .medgen-topbar .topbar-subtitle {\n    font-size: 11px !important;\n    opacity: 0.8 !important;\n    white-space: nowrap !important;\n    overflow: hidden !important;\n    text-overflow: ellipsis !important;\n  }\n\n  /* Hamburger touch target */\n  .hamburger-btn,\n  .medgen-topbar .hamburger-btn {\n    width: 40px !important;\n    height: 40px !important;\n    border-radius: 10px !important;\n    display: flex !important;\n    flex-direction: column !important;\n    justify-content: center !important;\n    align-items: center !important;\n    gap: 4px !important;\n    padding: 0 !important;\n    cursor: pointer !important;\n    flex-shrink: 0 !important;\n  }\n\n  .hamburger-btn span {\n    width: 18px !important;\n    height: 2px !important;\n    border-radius: 2px !important;\n  }\n\n  /* Mobile Drawer */\n  .mobile-drawer-backdrop {\n    position: fixed !important;\n    inset: 0 !important;\n    background: rgba(3, 6, 12, 0.72) !important;\n    backdrop-filter: blur(8px) !important;\n    -webkit-backdrop-filter: blur(8px) !important;\n    z-index: 1050 !important;\n  }\n\n  .mobile-drawer {\n    position: fixed !important;\n    top: 0 !important;\n    left: 0 !important;\n    width: min(320px, 86vw) !important;\n    height: 100dvh !important;\n    padding: 20px 16px !important;\n    background: linear-gradient(180deg, #06101f 0%, #0a182a 100%) !important;\n    border-right: 1px solid rgba(24, 183, 255, 0.18) !important;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5) !important;\n    z-index: 1100 !important;\n    display: flex !important;\n    flex-direction: column !important;\n    overflow-y: auto !important;\n    -webkit-overflow-scrolling: touch !important;\n  }\n\n  .mobile-drawer-header {\n    display: flex !important;\n    align-items: center !important;\n    justify-content: space-between !important;\n    padding-bottom: 16px !important;\n    margin-bottom: 16px !important;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;\n  }\n\n  .mobile-drawer-header h3 {\n    margin: 0 !important;\n    color: #ffffff !important;\n    font-size: 16px !important;\n    font-weight: 800 !important;\n    letter-spacing: -0.01em !important;\n  }\n\n  .mobile-drawer-header .btn {\n    padding: 6px 12px !important;\n    font-size: 12px !important;\n    border-radius: 8px !important;\n    background: rgba(255, 255, 255, 0.08) !important;\n    color: #d2e6f8 !important;\n    border: 1px solid rgba(255, 255, 255, 0.12) !important;\n  }\n\n  .mobile-drawer .app-sidebar-inner {\n    padding: 0 !important;\n    background: transparent !important;\n    border: none !important;\n    box-shadow: none !important;\n  }\n\n  .mobile-drawer .app-sidebar-title {\n    color: #89bfe8 !important;\n    font-size: 10px !important;\n    font-weight: 900 !important;\n    letter-spacing: 0.18em !important;\n    text-transform: uppercase !important;\n    margin-bottom: 10px !important;\n  }\n\n  .mobile-drawer .app-nav-link {\n    display: flex !important;\n    align-items: center !important;\n    min-height: 44px !important;\n    padding: 10px 14px !important;\n    border-radius: 10px !important;\n    font-size: 14px !important;\n    font-weight: 650 !important;\n    color: rgba(220, 235, 250, 0.85) !important;\n    background: transparent !important;\n    margin-bottom: 4px !important;\n    transition: all 0.16s ease !important;\n    text-decoration: none !important;\n  }\n\n  .mobile-drawer .app-nav-link:hover,\n  .mobile-drawer .app-nav-link.active {\n    background: rgba(31, 123, 193, 0.22) !important;\n    color: #ffffff !important;\n    border: 1px solid rgba(24, 183, 255, 0.3) !important;\n  }\n\n  .mobile-drawer .app-nav-link.active {\n    box-shadow: 0 4px 16px rgba(24, 183, 255, 0.16) !important;\n  }\n\n  /* Modals on iPad */\n  .modal-backdrop,\n  .admin-modal-backdrop {\n    padding: 16px !important;\n    overflow-y: auto !important;\n    -webkit-overflow-scrolling: touch !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n  }\n\n  .wizard-modal,\n  .admin-modal {\n    width: min(92vw, 640px) !important;\n    max-height: 90vh !important;\n    overflow-y: auto !important;\n    border-radius: 18px !important;\n    padding: 22px !important;\n  }\n}\n\n/* ==========================================================================\n   MOBILE PHONES (max-width: 768px)\n   ========================================================================== */\n@media (max-width: 768px) {\n  .topbar,\n  .medgen-topbar {\n    min-height: 58px !important;\n    padding: 8px 10px !important;\n    gap: 8px !important;\n  }\n\n  .medgen-topbar .topbar-subtitle {\n    display: none !important;\n  }\n\n  .topbar-title,\n  .medgen-topbar .topbar-title {\n    font-size: 15px !important;\n  }\n\n  .brand-mark,\n  .brand-mark-logo {\n    width: 32px !important;\n    height: 32px !important;\n    flex: 0 0 32px !important;\n  }\n\n  /* Right side compacting */\n  .medgen-topbar .theme-toggle {\n    min-width: 0 !important;\n    padding: 6px 9px !important;\n    font-size: 11px !important;\n    white-space: nowrap !important;\n  }\n\n  .medgen-topbar .btn-secondary {\n    padding: 6px 10px !important;\n    font-size: 11px !important;\n  }\n\n  .medgen-topbar .user-chip {\n    padding: 4px 8px 4px 4px !important;\n    gap: 6px !important;\n  }\n\n  .medgen-topbar .user-name {\n    font-size: 11px !important;\n    max-width: 60px !important;\n    white-space: nowrap !important;\n    overflow: hidden !important;\n    text-overflow: ellipsis !important;\n  }\n\n  .medgen-topbar .user-role {\n    display: none !important;\n  }\n\n  .medgen-topbar .user-avatar {\n    width: 26px !important;\n    height: 26px !important;\n    font-size: 10px !important;\n  }\n\n  /* Modals on mobile */\n  .wizard-modal,\n  .admin-modal {\n    width: 95vw !important;\n    max-height: 94vh !important;\n    padding: 16px 14px !important;\n    border-radius: 14px !important;\n  }\n\n  .wizard-header h2,\n  .admin-modal-header h2 {\n    font-size: 18px !important;\n  }\n}\n\n/* ==========================================================================\n   TINY MOBILE (max-width: 480px)\n   ========================================================================== */\n@media (max-width: 480px) {\n  .topbar,\n  .medgen-topbar {\n    padding: 6px 8px !important;\n  }\n\n  .topbar-title,\n  .medgen-topbar .topbar-title {\n    font-size: 14px !important;\n  }\n\n  .medgen-topbar .theme-toggle {\n    padding: 5px 8px !important;\n    font-size: 10px !important;\n  }\n\n  .medgen-topbar .user-name {\n    display: none !important;\n  }\n\n  .medgen-topbar .user-chip {\n    padding: 3px !important;\n    border-radius: 50% !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
